import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableNumber, nullableString } from '../utils/wire-value-utils';
import { SponsorRateCalculationMode } from './sponsor-rate-calculation-mode.model';

/**
 * A sponsor's point rate for one chemical, built from `/admin/sponsors/:id/rates` JSON
 * (hub `data-models/sponsor-point-rate.ts`).
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays `null`).
 */
export class SponsorPointRate extends Base {
  // Writable via POST / PUT /admin/sponsors/:id/rates
  chemicalId?: string | null;
  rateValue?: number | null;
  rateUnit?: string | null;
  calculationMode?: SponsorRateCalculationMode | null;
  /** ISO timestamp as sent by the hub. */
  effectiveStart?: string | null;
  /** ISO timestamp as sent by the hub; `null` is open-ended. */
  effectiveEnd?: string | null;

  // Read-only
  sponsorId?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.chemicalId = nullableString(source['chemicalId']);
    this.rateValue = nullableNumber(source['rateValue']);
    this.rateUnit = nullableString(source['rateUnit']);
    this.calculationMode = nullableString(source['calculationMode']) as SponsorRateCalculationMode | null | undefined;
    this.effectiveStart = nullableString(source['effectiveStart']);
    this.effectiveEnd = nullableString(source['effectiveEnd']);
    this.sponsorId = nullableString(source['sponsorId']);
  }
}
